import { useEffect, useState } from "react";
import { ChequeActivityConfirm, ChequeActivityData } from "../types";
import { BackContainer, Cheque } from "../../../../types";
import { ChequeDetails } from "../../../cheque";
import { ChequeApi } from "../../../../api";
import { useAlertStore } from "../../../../stores";

const ChequeConfirmActivityPopup = <T extends {}>(
  props: BackContainer<ChequeActivityData, T>
) => {
  const activity = props.data as ChequeActivityConfirm;

  const pushAlert = useAlertStore((s) => s.pushAlert);

  const [cheque, setCheque] = useState<Cheque | null>(null);

  useEffect(() => {
    ChequeApi.getById(activity.id.$oid)
      .then((c) => {
        setCheque(c);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return cheque ? <ChequeDetails {...cheque} back={props.back} /> : <></>;
};

export default ChequeConfirmActivityPopup;
